module.exports = __webpack_public_path__ + "static/linear-logo-animation-30a7c97113254564c4223b62f08085ae.mp4";